<template>
  <div class="mbheader" :class="{color:color}">
    <div class="left" @click="$router.go(-1)" v-if="left">
      <img src="../../assets/img/arrowl.png" alt="">
    </div>
    <div class="min">{{ title }}</div>
    <slot></slot>
    <div class="right" v-if="lang" @click="langChanged">
      <img src="../../assets/img/earth2.png" alt="" v-if="$route.name=='account'">
      <img src="../../assets/img/earth.png" alt="" v-else>
    </div>
  </div>
</template>

<script>
import {locales} from "../../mixin";

export default {
  name: "mbHeader",
  props: ['title', 'color', 'lang', 'left'],
  mixins: [locales]
}
</script>

<style scoped lang="less">
.mbheader {
  width: 100%;
  height: 50px;
  background-color: #131e1e;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 16px 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  &.color {
    background-color: #FFFFFF;

    .min {
      color: black;
    }
  }

  .left, .right {
    height: 30px;
    padding: 5px;
    position: relative;
    z-index: 2;

    img {
      height: 100%;
    }
  }

  .right {
    margin-left: auto;
  }

  .min {
    color: #FFFFFF;
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 1;
  }

  .search-bar {
    position: relative;
    margin-right: 10px;
    flex: 1;
    display: flex;

    .mobile-search-afm-search-type {
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translateY(-50%);
      height: 22px;
    }

    input {
      width: 100%;
      height: 30px;
      background-color: #FFFFFF;
      border-radius: 15px;
      color: #7cc26a;
      border: none;
      font-size: 12px;
      font-weight: bold;
      box-shadow: none;
      padding: 2px 10px 0 115px;
      font-family: 'Source Sans Pro';
      outline: none;
    }

    .hoverBtn {
      height: 22px;
      width: 22px;
      border-radius: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
      background-color: #7cc26a;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/mbHeader.vue